import styled from "styled-components";
import Satellite from "../../satellite/Satellite";

export default function SwitchSatellite({
  isSatellite,
  toggleDrawModeRef,
  drawMode,
  setDrawMode,
  result,
  setResult,
  whichMode,
  setWichMode,
  setCalculatedResult,
  calculatedHandler,
  isOpenMenu,
  handleOpenMenu,
  setRiskInfo
}) {
  return (
    <SwitchToSatelliteContainer>
      <Satellite
        drawModeRef={toggleDrawModeRef}
        isSatellite={isSatellite}
        drawMode={drawMode}
        setDrawMode={setDrawMode}
        result={result}
        setResult={setResult}
        whichMode={whichMode}
        setWichMode={setWichMode}
        setCalculatedResult={setCalculatedResult}
        calculatedHandler={calculatedHandler}
        isOpenMenu={isOpenMenu}
        handleOpenMenu={handleOpenMenu}
        setRiskInfo={setRiskInfo}
      />
    </SwitchToSatelliteContainer>
  );
}

const SwitchToSatelliteContainer = styled.div`
  .satellite-button {
    width: 100%;
    margin-bottom: 20px;
    padding: 10px;
  }
`;
